/**************
 Mobile Nav
 ***************/
// header element
const header = document.querySelector('#header');

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", function () {
        header.classList.add("active");
        document.querySelector("body").classList.add("noScroll");
    });
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", function () {
        header.classList.remove("active");
        document.querySelector("body").classList.remove("noScroll");
    });
});

// register dialog
// dialogPolyfill.registerDialog(document.querySelector("#slider"));

// listen for header reaching top of viewport, make opaque
window.addEventListener('scroll', function () {
    if (window.scrollY > 0) {
        header.classList.add('atTop');
    } else {
        header.classList.remove('atTop');
    }
});